<template>
    <div class="layer-content common">
        <!--
        <div class="term-tit2"><b>임시계정 발급 규칙을 알려드리면</b></div>
        <ol>
            <li style="color:blue">1. 아이디 : 사업자번호</li>
            <li style="color:blue">2. 비밀번호 : 신청서상의 연락처번호</li>
        </ol>
        <div class="term-tit2"><b>입니다.</b></div>
        <div class="term-tit2"><b>위 규칙대로도 로그인이 되지 않으면 아직 본사의 접수처리, 관리시스템 등록을 진행하는 기간일 수 있습니다.</b></div>
        <div class="term-tit2"><b>늦어지는 경우 고객지원(1661-5029)으로 반드시 문의하시기 바랍니다.</b></div>
        -->
        <p>
            <b><span style="font-size: 10pt;">임시계정을 문자로 받으신 원장님은</span></b>
        </p>
        <p><b style="font-size: 10pt;">문자의 내용대로&nbsp;</b><br></p>
        <p>
            <b style="font-size: 10pt;">
                <span style="font-size: 10pt; color: rgb(0, 85, 255);">1. 아이디 : 사업자번호</span>
            </b><br>
        </p>
        <p>
            <span style="font-size: 10pt;">
                <b>
                    <span style="color: rgb(0, 85, 255);">2. 비밀번호 : 신청서상의 연락처번호 (핸드폰번호 또는 어린이집 대표번호)</span>
                </b>
            </span>
        </p>
        <p>
            <b style="font-size: 10pt;">로그인을 하시고 아이오감을 시작하실 수 있습니다.</b><br>
        </p>
        <p>
            <b style="font-size: 13.3333px;">
                <span style="color: rgb(0, 85, 255);"><br></span>
            </b>
        </p>
        <p>
            <b style="font-size: 13.3333px;">
                <span style="color: rgb(0, 85, 255);">매뉴얼을 보시고 따라하시면 쉽게 시작하실 수 있습니다!</span>
            </b><br>
        </p>
        <p>
            <b><br></b>
        </p>
        <p>
            <b>
                <span style="color: rgb(255, 0, 0);">문자를 못 받은 원장님은 '<span style="color: rgb(0, 0, 0);">회원가입</span>'을하시고 '
                    <span style="color: rgb(0, 0, 0);">서비스 신청</span>'을 하여 주시기 바랍니다.
                </span>
            </b>
        </p>
        <p>
            <span style="font-size: 13.3333px;"><br></span>
        </p>
	</div>
</template>

<script>
    export default {
        name : 'tosAgreePopup',
        data : function(){
            return {
            }
        },
        methods: {
        },
    }
</script>